import Http from 'utils/Http';

const apiEndPoints = {
  getTournamentList: 'sfa_online.v1.profile.get_participated_tournaments',
  getNotificationsList: 'sfa_online.v1.profile.get_notifications',
  getTournamentEventsList: 'sfa_online.v1.profile.tournament_list_events',
  getMatchDetailsBySportEvent: 'sfa_online.v1.profile.get_match_details',
  getMedalWinnerBySportEvent: 'sfa_online.v1.profile.medal_winners_by_sport_event',
  getTournamentDetails: 'sfa_online.v1.profile.get_tournament_details',
  getSportListByTournamentId: 'sfa_online.v1.profile.tournament_list_sports',
  getSportEventList: 'sfa_online.v1.profile.tournament_list_sport_events_by_sport',
  getMatchFixtureDates: 'sfa_online.v1.profile.get_match_fixture_dates',
  getMatchFixturesList: 'sfa_online.v1.profile.get_match_fixtures',
  getAccommodationDetails: 'sfa_online.v1.act.get_accomodation',
  getContingentList: 'sfa_online.v1.profile.get_contingent',
  getContingentDetails: 'sfa_online.v1.profile.get_contingent_details',
  getAllSportEventsUnderTournamentList: 'sfa_online.v1.profile.get_sport_event_participants',
  getTeamUnderSportEventList: 'sfa_online.v1.registrations.team.list_teams',
  getProfileOverview: 'sfa_online.v1.profile.get_institution_public_profile',
  getProfileRank: 'sfa_online.v1.profile.get_institution_rank',
  getTeamDetails: 'sfa_online.v1.registrations.team.get_team_details',
  getTeamPlayersList: 'sfa_online.v1.registrations.team.list_players',
  postCreateTeam: 'sfa_online.v1.registrations.team.create_team',
  postDeleteTeam: 'sfa_online.v1.registrations.team.delete_team',
  postDeleteParticipant: 'sfa_online.v1.registrations.team.delete_participant',
  getTeamMedalWinners: 'sfa_online.v1.registrations.team.medal_winners',
  getTeamMatchFixtures: 'sfa_online.v1.registrations.team.team_match_fixtures',
  getTeamConfimationForm: 'sfa_online.v1.registrations.team.get_sport_form',
  getSubmittedFormData: 'sfa_online.v1.registrations.team.get_sport_filled_data',
  postTeamSubmitSportForm: 'sfa_online.v1.registrations.team.submit_sport_form',
  postConfirmTeam: 'sfa_online.v1.registrations.team.confirm_team',
  getCoachVerificationStatus: 'sfa_online.v1.registrations.team.get_coach_verfication_status',
  getBillingDetails: 'sfa_online.v1.registrations.athlete_billing_details.get_billing_details',
  applyRefund: 'sfa_online.v1.registrations.athlete_billing_details.apply_for_refund',
  getInstitutionVerificationStatus: 'sfa_online.v1.profile.check_institution_verification_status',
  getSportVideoId: 'sfa_online.v1.profile.get_sport_video_id',
  canShowDigitalScoring: 'sfa_online.v1.profile.can_show_scoring',
  getMatchAnalytics: 'sfa_online.v1.digital_scoring.get_analytics',
  getAchievements: 'sfa_online.v1.achievements.get_achievements',
  getAchievementFilters: 'sfa_online.v1.achievements.get_filters',
  getProfileVideos: 'sfa_online.v1.profile.get_profile_videos',
};

export async function getTournamentList(active) {
  try {
    const res = await Http.fetch({
      apiEndpoint: apiEndPoints.getTournamentList,
    });
    return active ? res.message.participated_tournaments : res.message.upcomming_tournament;
  } catch (error) {
    console.log(error);
  }
}

export async function getNotificationsList() {
  try {
    const res = await Http.fetch({
      apiEndpoint: apiEndPoints.getNotificationsList,
    });
    return res.message.notifications;
  } catch (error) {
    console.log(error);
  }
}

export async function getTournamentEventsList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTournamentEventsList}?tournament_id=${params.tournament_id}`,
    });
    return res.message.events;
  } catch (error) {
    console.log(error);
  }
}

export async function getMatchDetailsBySportEvent(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getMatchDetailsBySportEvent}?sport_event=${params.sportEvent}`,
    });
    return res.message.match_details;
  } catch (error) {
    console.log(error);
  }
}

export async function getMedalWinnerBySportEvent(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getMedalWinnerBySportEvent}?sport_event=${params.sportEvent}`,
    });
    return res.message.winners;
  } catch (error) {
    console.log(error);
  }
}

export async function getTournamentDetails(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTournamentDetails}?tournament_id=${params.tournamentId}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getAccommodationDetails(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getAccommodationDetails}?user_id=${params.user_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportListByTournamentId(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSportListByTournamentId}?tournament_id=${params.tournamentId}`,
    });
    return res.message.sports;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportEventList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSportEventList}?tournament_id=${params.tournamentId}&sport=${params.sport}`,
    });
    return res.message.events;
  } catch (error) {
    console.log(error);
  }
}

export async function getMatchFixtureDates(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getMatchFixtureDates}?tournament_id=${params.tournamentId}&institution=${params.institution}`,
    });
    return res.message.dates;
  } catch (error) {
    console.log(error);
  }
}

export async function getMatchFixturesList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getMatchFixturesList}?tournament_id=${params.tournamentId}&institution=${params.institution}&date=${params.date}`,
    });
    return res.message.match_fixtures;
  } catch (error) {
    console.log(error);
  }
}

export async function getContingentList(params) {
  try {
    const res = await Http.fetch({
      method: 'POST',
      apiEndpoint: `${apiEndPoints.getContingentList}`,
      options: {
        tournament_id: params?.tournamentId,
      },
    });
    return res.message.contingent;
  } catch (error) {
    console.log(error);
  }
}

export async function getContingentDetails(params) {
  console.log(params);
  try {
    const res = await Http.fetch({
      method: 'POST',
      apiEndpoint: `${apiEndPoints.getContingentDetails}`,
      options: {
        tournament_participant_id: params?.id,
      },
    });
    return res.message.sport_events;
  } catch (error) {
    console.log(error);
  }
}

export async function getAllSportEventsUnderTournamentList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getAllSportEventsUnderTournamentList}?tournament_id=${params.tournament_id}&gender=${params.gender}&age_category=${params.age_category}&sport=${params.sport}&sport_category=${params.sport_category}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getProfileOverview(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getProfileOverview}?tournament_id=${params.id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getTeamUnderSportEventList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTeamUnderSportEventList}?sport_event=${params.sport_event}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getProfileRank(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getProfileRank}?tournament_id=${params.id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getTeamDetails(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTeamDetails}?team_id=${params.team_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getTeamPlayersList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTeamPlayersList}?sport_event=${params.sport_event}&verification_status=${params.verification_status}&team_id=${params.team_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function postCreateTeam(params) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.postCreateTeam}`,
      method: 'POST',
      options: params,
    });
  } catch (error) {
    throw error.message;
  }
}

export async function postDeleteTeam(params) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.postDeleteTeam}`,
      method: 'POST',
      options: params,
    });
  } catch (error) {
    throw error.message;
  }
}

export async function postDeleteParticipant(params) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.postDeleteParticipant}`,
      method: 'POST',
      options: params,
    });
  } catch (error) {
    throw error.message;
  }
}

export async function getTeamMedalWinners(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTeamMedalWinners}?sport_event=${params.sport_event}`,
    });
    return res.message.winners;
  } catch (error) {
    console.log(error);
  }
}

export async function getTeamMatchFixtures(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTeamMatchFixtures}?sport_event=${params.sport_event}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getTeamConfimationForm(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTeamConfimationForm}?team_id=${params.team_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getSubmittedFormData(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSubmittedFormData}?team_id=${params.team_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function postTeamSubmitSportForm(params) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.postTeamSubmitSportForm}`,
      method: 'POST',
      options: params,
    });
  } catch (error) {
    throw error.message;
  }
}

export async function postConfirmTeam(params) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.postConfirmTeam}`,
      method: 'POST',
      options: params,
    });
  } catch (error) {
    throw error.message;
  }
}

export async function getCoachVerificationStatus(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getCoachVerificationStatus}?tournament_id=${params.tournament_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}
export async function getInstitutionVerificationStatus() {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.getInstitutionVerificationStatus}`,
    });
  } catch (error) {
    console.log(error);
  }
}

export async function getProfileBillingInformation(_params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getBillingDetails}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function submitRefundForm(params) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.applyRefund}`,
      method: 'POST',
      options: params,
    });
  } catch (error) {
    throw error.message;
  }
}

export async function getSportVideoId(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: apiEndPoints.getSportVideoId,
      method: 'POST',
      options: params,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function canShowDigitalScoring({ tournamentId }) {
  try {
    return await Http.fetch({
      apiEndpoint: `${apiEndPoints.canShowDigitalScoring}?tournament_id=${tournamentId}`,
    });
  } catch (error) {
    console.log(error);
  }
}

export async function getMatchAnalytics({ matchId }) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getMatchAnalytics}?match_id=${matchId}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getAchievements(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getAchievements}?medal=${params.medal}&tournament=${params.tournament}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getAchievementFilters() {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getAchievementFilters}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getProfileVideos(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getProfileVideos}?sports=${params.sports}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}
